import { msg } from '@gonfalon/messages/msg';

// Plain string, not <Message />: this fallback renders inside React Aria collections (TagGroup),
// whose renderer cannot create a text node for a nested component.
export const QuietError = () => {
  if (process.env.NODE_ENV !== 'production') {
    return <div>{msg('errors.quietError.body')}</div>;
  }

  return null;
};
